export const CONSTANTS = {
	RESETALL: Symbol("Performances/ResetAll")
};

export const initialState = {
	loading: false,
	values: null
};

/**
 * Reducer managing contingent.
 *
 * @name PerformanceReducer
 *
 * @param {Object} state - Current application state
 * @param {AbstractAction} action - Action to dispatch
 * @return {Object} new state
 */
export default (state = initialState, action) => {
	if (!action.isAction) {
		switch (action.type) {
			case CONSTANTS.RESETALL:
				return initialState;
			default:
				return state;
		}
	}

	return action.performPerformanceReducer(state);
};
